export default `

![Lead image](https://picsum.photos/1400/200?image=4)

# 使い方


## <i aria-hidden="true" class="square icon"></i> テキスト/Text

文章です / This is paragrah.

# タイトル1 / heading1
## タイトル2 / heading2
### タイトル3 / heading3

*イタリック / Italic*

**太文字 / Bold**

~~取り消し線 / Strikethrough~~

> Quoting text<br/>
> 引用コメント

## <i aria-hidden="true" class="square icon"></i>リスト/Lists

* Todo
  1. item
  2. item2
* Food
  * apple
  * orange

## <i aria-hidden="true" class="square icon"></i> 外部リンク/Link

[I'm an inline-style link](https://www.google.com)

## <i aria-hidden="true" class="square icon"></i> 画像/Image

![this is image](https://picsum.photos/1400/200?image=140)

## <i aria-hidden="true" class="square icon"></i> コード/Code

\`\`\`js
hello ()  {
    alert ( \`Hello, Writedown app.\` )
  }
\`\`\`

## <i aria-hidden="true" class="square icon"></i> 表/Tables

| Tables        | Are           | Cool  |
| ------------- |:-------------:| -----|
| col 3 is      | right-aligned | $1600 |
| col 2 is      | centered      |   $12 |
| zebra stripes | are neat      |    $1 |

`;
